/* Imports */
import axios from "../api/api";
/* /Imports/ */

/* 
  Class: AuthService
  Description: This class is responsible for authentication stuff.
*/
class AuthService {
  /* 
    Sign in the user in the system.
  */
  login(user) {
    return axios.post("api/auth/login", {
      email: user.email,
      password: user.password,
    }).then((response) => {
      if (response.data.token) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
  }

  /* 
    Sign up the user in the system.
  */
  register(user) {
    return axios.post("api/auth/register", user);
  }

  /* 
    Sign out the user from the system.
  */
  logout() {
    localStorage.removeItem("user");
  }
}

export default new AuthService();